// Статистика на един имот: събран наем, заетост 12 мес., депозит, откога е
// текущият наемател, щети/ремонти (отстранени ли са и за колко пари).

import React, { useCallback, useState } from 'react';
import { Text, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { api, money } from '../../api';
import { showError } from '../../toast';
import { getLocale, t } from '../../i18n';
import { Badge, Card, COLORS, Divider, Muted, Row, Screen, SectionLabel, Title } from '../../ui';

export default function ApartmentStatsScreen({ route }: any) {
  const { id, address } = route.params;
  const [s, setS] = useState<any>(null);

  const load = useCallback(() => {
    api(`/apartments/${id}/stats`).then(setS).catch((e) => showError(e.message));
  }, [id]);
  useFocusEffect(load);

  if (!s) return <Screen><Muted>{t('Зареждане…')}</Muted></Screen>;

  return (
    <Screen>
      <Title>{t('Статистика')}</Title>
      {address ? <Muted>{address}</Muted> : null}

      <SectionLabel>{t('Наем')}</SectionLabel>
      <Card>
        <Row left={t('Събран наем (общо)')} right={money(s.rentCollectedCents)} />
        <Divider />
        <Row left={t('Последните 12 месеца')} right={money(s.rentCollected12mCents)} />
      </Card>

      <SectionLabel>{t('Заетост (последните 12 месеца)')}</SectionLabel>
      <Card>
        <Text style={{ fontSize: 30, fontWeight: '800', color: COLORS.text }}>{s.occupancy.percent}%</Text>
        <Muted>{t('{n} от 12 месеца имотът е бил отдаден', { n: s.occupancy.occupiedMonths })}</Muted>
        {/* прост бар */}
        <View style={{ height: 10, backgroundColor: COLORS.bg, borderRadius: 6, marginTop: 8, overflow: 'hidden' }}>
          <View style={{ width: `${s.occupancy.percent}%`, height: 10, backgroundColor: COLORS.primary }} />
        </View>
      </Card>

      <SectionLabel>{t('Депозит')}</SectionLabel>
      <Card>
        <Row left={t('Взет депозит')} right={money(s.depositCents)} />
      </Card>

      <SectionLabel>{t('Настоящ наемател')}</SectionLabel>
      <Card>
        {s.currentTenant ? (
          <>
            <Text style={{ fontWeight: '700', color: COLORS.text, fontSize: 16 }}>{s.currentTenant.name}</Text>
            <Muted>
              {s.currentTenant.months === 1 ? t('Наемател от 1 месец') : t('Наемател от {n} месеца', { n: s.currentTenant.months })} ·{' '}
              {t('от {date}', { date: new Date(s.currentTenant.since).toLocaleDateString(getLocale() === 'en' ? 'en-GB' : 'bg-BG') })}
            </Muted>
            <Muted>{t('Месечен наем: {amount}', { amount: money(s.currentTenant.monthlyRentCents) })}</Muted>
          </>
        ) : (
          <Muted>{t('В момента няма наемател.')}</Muted>
        )}
      </Card>

      <SectionLabel>
        {t('Щети и ремонти')} {s.damageCount > 0 ? t('({resolved}/{total} отстранени)', { resolved: s.resolvedDamageCount, total: s.damageCount }) : ''}
      </SectionLabel>
      {s.damages.length === 0 && (
        <Card><Muted>{t('Няма регистрирани щети или ремонти за този имот. 👍')}</Muted></Card>
      )}
      {s.damages.length > 0 && (
        <Card>
          <Row left={t('Общо платено за ремонти')} right={money(s.totalRepairCents)} />
        </Card>
      )}
      {s.damages.map((d: any) => (
        <Card key={d.id}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text style={{ fontWeight: '600', color: COLORS.text, flex: 1 }}>{d.title}</Text>
            <Badge
              text={d.resolved ? t('Отстранено ✓') : t('В процес')}
              color={d.resolved ? COLORS.success : '#D97706'}
            />
          </View>
          <Muted>
            {new Date(d.createdAt).toLocaleDateString(getLocale() === 'en' ? 'en-GB' : 'bg-BG')}
            {d.costCents > 0 ? ` · ${t('ремонт за {amount}', { amount: money(d.costCents) })}` : ` · ${t('без платен ремонт')}`}
          </Muted>
        </Card>
      ))}
    </Screen>
  );
}
